import React, { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import LineCopyIcon from 'LuxKit/Icons/line/LineCopyIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import { copyValueToClipboard } from 'lib/web/clipboardUtils'
import Clickable from 'components/Common/Clickable'

interface Props {
  value: string
  onCopyClick?: (event: React.MouseEvent<HTMLElement>) => void
  ariaLabel?: string
}

function CopyToClipboardClickableIcon(props: Props) {
  const { value, onCopyClick, ariaLabel } = props
  const intl = useIntl()

  const defaultAriaLabel = intl.formatMessage({
    id: 'OmhFnzHVTqf_B4xpe5PA',
    defaultMessage: 'Copy to clipboard',
    description: 'Default aria label for copy to clipboard button on the checkout confirmation page',
  })

  const [hasCopied, setCopied] = useState<boolean>(false)

  const copyToClipboard = useCallback(async(event?: React.MouseEvent<HTMLElement>) => {
    if (hasCopied) {
      return
    }

    if (onCopyClick && event) {
      onCopyClick(event)
    }

    await copyValueToClipboard(value)

    setCopied(true)
    window.setTimeout(() => {
      setCopied(false)
    }, 1000)
  }, [hasCopied, onCopyClick, value])

  return (
    <Clickable onClick={copyToClipboard} disabled={hasCopied} aria-label={ariaLabel ?? defaultAriaLabel}>
      {hasCopied ? <LineCheckIcon size="XS" /> : <LineCopyIcon size="XS" />}
    </Clickable>
  )
}

export default CopyToClipboardClickableIcon
